import { usePage } from "@inertiajs/react"
import Button from "./Button"
import { PlusIcon } from "@heroicons/react/20/solid"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import Pagination from "./Pagination"
import GameItem from "./GameItem"
import SearchInput from "./SearchInput"
import useCreateGame from "@/hooks/useCreateGame"
import SortingSelector from "./SortingSelector"
import { GamesIndexProps } from "@/types/types"
import { WP } from "./pieces"

const GamesList = () => {
  const { createGame, processing } = useCreateGame()
  const { games, filters } = usePage<GamesIndexProps>().props
  const search = filters.search || ""

  const hasNoGames = !search && games.length === 0

  return (
    <div className="flex flex-1 flex-col pt-6">
      {hasNoGames ? (
        <div className="padding mx-auto flex max-w-xs flex-col items-center justify-center py-10">
          <div className="flex items-center justify-center rounded-xl bg-gray-200 p-3">
            <WP className="h-6 w-6 text-gray-500" />
          </div>
          <h3 className="my-4 text-center text-base leading-6 font-semibold text-gray-900">
            Create your first game
          </h3>
          <Button loading={processing} size="sm" onClick={createGame}>
            <PlusIcon className="h-5 w-5" />
            <span>Add game</span>
          </Button>
        </div>
      ) : (
        <>
          <div className="padding relative flex flex-col items-start justify-start gap-x-8 gap-y-4 sm:flex-row sm:items-center">
            <SearchInput />
            <SortingSelector type="games" />
          </div>

          <div className="relative mt-6 flex flex-1 flex-col">
            {games && games.length > 0 ? (
              <>
                <ul
                  role="list"
                  className="divide-y divide-gray-200 border-y border-gray-200"
                >
                  {games.map((game) => (
                    <GameItem key={game.id} {...game} />
                  ))}
                </ul>

                <div className="flex-1" />

                <Pagination type="game" />
              </>
            ) : (
              <div className="padding mx-auto flex max-w-xs flex-col items-center justify-center py-10">
                <div className="flex items-center justify-center rounded-xl bg-gray-200 p-3">
                  <MagnifyingGlassIcon className="h-6 w-6 text-gray-500" />
                </div>
                <h3 className="mt-4 text-center text-base leading-6 font-semibold text-gray-900">
                  No games found.
                </h3>
                <p className="text-center text-sm text-gray-700">
                  &ldquo;{search}&rdquo; did not match the title of any game.
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default GamesList
